import { ROUTE_NAMES } from './routeNames.const'

export const routeReallocation = {
  path: '/reallocation/:stage?',
  name: ROUTE_NAMES.reallocation,
  component: () =>
    import(
      /* webpackChunkName: "Reallocation" */ 'src/pages/Reallocation/Reallocation.vue'
    ),
  props: true,
}
